<template>
  <!-- jedna kategorija dogadjaja (pocetna), bez slike; from/to biraju opseg (npr. 0-8, pa 8-16) -->
  <EventsBlock
    :items="items"
    :filter="{ top_event: false, category_name: category_name }"
    :offset="from"
    :limit="to - from"
    :year="year"
    :month="month"
    :title="category_name"
    :category="category_name"
    show-all
    :show-image="false"
  />
</template>

<script setup>
import EventsBlock from '~/components/widgets/Event/EventsBlock.vue'

defineProps({
  items: { type: Array, default: () => [] },
  from: { type: Number, default: 0 },
  to: { type: Number, default: 8 },
  year: Number,
  month: String,
  category_name: String,
})
</script>
